import { Box } from 'styled-system/jsx';
import DelayAlertIcon from '@/common/assets/icons/delayAlert.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import { delayAlertType } from '@/modules/FileDetail/queries/alerts/alertsQuery.type';

const DelayAlert = ({ delayAlertItem }: { delayAlertItem: delayAlertType }) => {
  const { days, hours, fa_type } = delayAlertItem;
  const delayText = `${days ? `${days} روز` : ''}${days && hours ? ' و ' : ''}${hours ? `${hours} ساعت` : ''} ${fa_type}`;

  return (
    <Box
      p="12px 44px"
      background={'delayLinear'}
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap="4px"
      borderRadius="8px"
    >
      <Box>
        <DelayAlertIcon />
      </Box>
      <Typography textStyle="b1" color="red" textWrap="nowrap">
        {delayText}
      </Typography>
    </Box>
  );
};
export default DelayAlert;
